import React from 'react'

export const themes = {
    light: {
        primary_color: '#3C4B64',
        info_color: '#2F97C1',
        success_color: '#04A777',
        warning_color: '#F9B115',
        error_color: '#E55353'
    },
    dark: {
        primary_color: '#FFFFC4',
        info_color: '#2F97C1',
        success_color: '#04A777',
        warning_color: '#F9B115',
        error_color: '#E55353'
    }
}

export const defaultSetting = {
    theme: 'light',
    pagination_size: 20,
    pagination_options: [ "10", "20", "30", "50" ],
    language: 'it_IT',
    form_layout: {
        labelCol: { span: 8 },
        wrapperCol: { span: 8 }
    }
}

export const CondolenceWallContext = React.createContext()
export const CondolenceWallConsumer = CondolenceWallContext.Consumer
export const CondolenceWallProvider = CondolenceWallContext.Provider